const LocalStorageService = (() => {
  let service
  function getService() {
    if (!service) {
      service = this
      return service
    }
    return service
  }

function setUser(userObj) {
  let toUserStorage;
  let schoolId;
  let offers;

  if (userObj.user) {
    // Response from /api/login: { user: {...}, student: {...}, offers: [...] }
    toUserStorage = userObj.user;
    schoolId = userObj.student ? userObj.student.school : null;
    // Offers are at root level for /api/login response
    offers = userObj.offers || userObj.user.offers || null;
  } else if (userObj.data && userObj.data.user) {
    toUserStorage = userObj.data.user;
    schoolId = userObj.school;
    offers = userObj.data.user.offers || userObj.data.offers || null;
  } else {
    console.error('Invalid user object structure:', userObj);
    return;
  }

  let currentContracts = userObj.contracts !== undefined ? userObj.contracts : null;

  const contracts = [];
  if (currentContracts !== null) {
    currentContracts.forEach(contract => {
      contracts.push(contract);
    });
  }

  localStorage.setItem('user_email', toUserStorage.email);
  localStorage.setItem('user_lastname', toUserStorage.lastName);
  localStorage.setItem('user_name', toUserStorage.name);
  localStorage.setItem('user_role', toUserStorage.roles && toUserStorage.roles.length > 0 ? toUserStorage.roles[0] : "none");
  localStorage.setItem('user_referralCode', toUserStorage.referralCode);
  localStorage.setItem('user_referredBy', toUserStorage.referredBy);
  localStorage.setItem('user_hasUsedReferralDiscount', toUserStorage.hasUsedReferralDiscount);
  localStorage.setItem('school', schoolId);
  localStorage.setItem('offers', offers && Array.isArray(offers) && offers.length > 0 ? JSON.stringify(offers) : "none");
  localStorage.setItem('currentContracts', contracts && contracts.length > 0 ? JSON.stringify(contracts) : "none");
}

  function getUser() {
    let user = {};
    user.email = localStorage.getItem('user_email');
    user.lastName = localStorage.getItem('user_lastname');
    user.name = localStorage.getItem('user_name');
    user.roles = [localStorage.getItem('user_role')];
    user.referralCode = localStorage.getItem('user_referralCode');
    user.referredBy = localStorage.getItem('user_referredBy');
    user.hasUsedReferralDiscount = localStorage.getItem('user_hasUsedReferralDiscount');
    user.school = [localStorage.getItem('school')];

    // Parse offers if it's a JSON string, otherwise return the raw value
    const offersValue = localStorage.getItem('offers');
    try {
      user.offers = (offersValue && offersValue !== "none") ? JSON.parse(offersValue) : [];
    } catch (e) {
      console.error('Error parsing offers from localStorage:', e);
      user.offers = [];
    }

    // Parse currentContracts if it's a JSON string, otherwise return the raw value
    const contractsValue = localStorage.getItem('currentContracts');
    try {
      user.currentContracts = (contractsValue && contractsValue !== "none") ? JSON.parse(contractsValue) : [];
    } catch (e) {
      console.error('Error parsing currentContracts from localStorage:', e);
      user.currentContracts = [];
    }

    return user;
  }

  function clearUser(){
    localStorage.removeItem('user_email');
    localStorage.removeItem('user_lastname');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_role');
    localStorage.removeItem('user_referralCode');
    localStorage.removeItem('user_referredBy');
    localStorage.removeItem('user_hasUsedReferralDiscount');
    localStorage.removeItem('school');
    localStorage.removeItem('offers');
    localStorage.removeItem('currentContracts');
  }

  function setToken(tokenObj) {
    localStorage.setItem('token', tokenObj.token)
    localStorage.setItem('refresh_token', tokenObj.refresh_token)
  }

  function getAccessToken() {
    return localStorage.getItem('token')
  }

  function getRefreshToken() {
    return localStorage.getItem('refresh_token')
  }

  function clearToken() {
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
  }

  function setHouseContract(obj) {
    localStorage.setItem('houseContract', JSON.stringify(obj));
  }

  function getHouseContract() {
    const value = localStorage.getItem('houseContract');
    return JSON.parse(value);
  }

  function removeHouseContract() {
    localStorage.removeItem('houseContract')
  }

  function setHealthMobilityContract(obj) {
    localStorage.setItem('healthMobilityContract', JSON.stringify(obj));
  }

  function getHealthMobilityContract() {
    const value = localStorage.getItem('healthMobilityContract');
    return JSON.parse(value);
  }

  function removeHealthMobilityContract() {
    localStorage.removeItem('healthMobilityContract')
  } 

  function setMultimediaContract(obj) {
    localStorage.setItem('multimediaContract', JSON.stringify(obj));
  }

  function getMultimediaContract() {
    const value = localStorage.getItem('multimediaContract');
    return JSON.parse(value);
  }

  function removeMultimediaContract() {
    localStorage.removeItem('multimediaContract')
  } 

  function setLanguage(obj) {
    localStorage.setItem('language', JSON.stringify(obj));
  }

  function getLanguage() {
    const value = localStorage.getItem('language');
    return JSON.parse(value);
  }

  function updateReferralDiscountFlag(value) {
    localStorage.setItem('user_hasUsedReferralDiscount', value);
  }
  

  return {
    getService,
    getUser,
    setUser,
    clearUser,
    setToken,
    getAccessToken,
    getRefreshToken,
    clearToken,
    setHouseContract,
    getHouseContract,
    removeHouseContract,
    setHealthMobilityContract,
    getHealthMobilityContract,
    removeHealthMobilityContract,
    setMultimediaContract,
    getMultimediaContract,
    removeMultimediaContract,
    setLanguage,
    getLanguage,
    updateReferralDiscountFlag
  }
})()

export default LocalStorageService
